import { EnumOption } from './enum-option';

export const AddressType = {
  Residence: 0,
  Work: 1,
  Foreign: 2,
  Other: 3
}

export const AddressTypeList: EnumOption[] = [
  { value: AddressType.Residence, label: 'Residence' },
  { value: AddressType.Work, label: 'Work' },
  { value: AddressType.Foreign, label: 'Foreign' },
  { value: AddressType.Other, label: 'Other' }
];